module.exports = __webpack_public_path__ + "static/waternet.006494b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/waternet.png
// module id = 590
// module chunks = 35783957827783